import {Point} from '../../../model/Point';
import {ElementType} from '../../../dataSource/constant/ElementType';
import {DrawTool} from './DrawTool';
import {Cursor} from '../../../dataSource/constant/Cursor';
import {Drawable} from './type/Drawable';
import {Container} from '@app/modules/svg/Container';
import {ElementView} from '@app/modules/svg/element/ElementView';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';

export abstract class Drawer {
  protected abstract _drawableElement: Drawable | undefined;
  public drawTool: DrawTool;
  public cursor: Cursor = Cursor.DRAW;

  protected constructor(drawTool: DrawTool) {
    this.drawTool = drawTool;
  }

  public abstract makeMouseDown(position: Point, call?: boolean, parameter?: any): void;
  public abstract makeMouseMove(position: Point, call?: boolean, parameter?: any): void;
  public abstract makeMouseUp(position: Point, call?: boolean, parameter?: any): void;

  protected mouseDownEvent(event: MouseEvent | TouchEvent): void {
    document.addEventListener('mousemove', this.mouseMoveEvent);
    document.addEventListener('touchmove', this.mouseMoveEvent);
    document.addEventListener('mouseup', this.mouseUpEvent);
    document.addEventListener('touchend', this.mouseUpEvent);

    const containerRect: DOMRect = this.drawTool.container.HTML.getBoundingClientRect();
    const eventPosition: Point = Container.eventToPosition(event);
    this.drawTool.__mouseCurrentPos__ = {
      x: eventPosition.x - containerRect.left,
      y: eventPosition.y - containerRect.top
    };

    this.makeMouseDown(this.drawTool.mouseCurrentPos);
  };
  protected abstract mouseMoveEvent(event: MouseEvent | TouchEvent): void;
  protected abstract mouseUpEvent(event: MouseEvent | TouchEvent): void;

  public abstract _new(): Drawer;
  public abstract get type(): ElementType;
  public abstract get drawableElement(): Drawable | undefined;

  public abstract stopDrawing(call?: boolean): void;
  public abortDrawing(call?: boolean) {
    if (!this._drawableElement || !this.drawTool.isDrawing) {return;}
    this.drawTool.container.remove(this._drawableElement as unknown as ElementView, true, true);
    this._drawableElement = undefined;

    this.drawTool.__drawingEnd__();

    if (call) {
      this.drawTool.container.__call__(SVGEvent.ABORT_DRAWING);
      this.drawTool.container.__call__(SVGEvent.END_DRAWING, {drawer: this});
    }
  }

  public abstract start(call?: boolean): void;
  public abstract stop(call?: boolean): void;
}
